import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
interface AnimatedCircularProgressBarProps {
  max?: number;
  min?: number;
  value: number;
  className?: string;
}
export function AnimatedCircularProgressBar(t0) {
  const $ = _c(16);
  const {
    max: t1,
    min: t2,
    value: t3,
    className
  } = t0;
  const max = t1 === undefined ? 100 : t1;
  const min = t2 === undefined ? 0 : t2;
  const value = t3 === undefined ? 0 : t3;
  const circumference = 2 * Math.PI * 45;
  const percentPx = circumference / 100;
  const currentPercent = Math.round((value - min) / (max - min) * 100);
  let t4;
  if ($[0] !== className) {
    t4 = cn("relative size-40 text-2xl font-semibold [--stroke-primary:rgb(79_70_229)] [--stroke-secondary:rgba(0,0,0,0.1)]", className);
    $[0] = className;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      "--circle-size": "100px",
      "--circumference": circumference,
      "--percent-to-px": `${percentPx}px`,
      "--gap-percent": "5",
      "--offset-factor": "0",
      "--transition-length": "1s",
      "--transition-step": "200ms",
      "--delay": "0s",
      "--percent-to-deg": "3.6deg",
      transform: "translateZ(0)"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== currentPercent) {
    t6 = currentPercent <= 90 && currentPercent >= 0 && <circle cx="50" cy="50" r={39} strokeWidth={22} strokeDashoffset="-10" strokeLinecap="round" strokeLinejoin="round" className="[stroke:var(--stroke-secondary)] opacity-100" style={{
      "--stroke-percent": 90 - currentPercent - 20,
      "--offset-factor-secondary": "calc(1 - var(--offset-factor))",
      strokeDasharray: "calc(var(--stroke-percent) * var(--percent-to-px)) var(--circumference)",
      transform: "rotate(calc(1turn - 90deg - (var(--gap-percent) * var(--percent-to-deg) * var(--offset-factor-secondary)))) scaleY(-1)",
      transition: "all var(--transition-length) ease var(--delay)",
      transformOrigin: "calc(var(--circle-size) / 2) calc(var(--circle-size) / 2)"
    }} />;
    $[3] = currentPercent;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== currentPercent) {
    t7 = <circle cx="50" cy="50" r={39} strokeWidth={22} strokeDashoffset="0" strokeLinecap="round" strokeLinejoin="round" className="[stroke:var(--stroke-primary)] opacity-100" style={{
      "--stroke-percent": currentPercent,
      strokeDasharray: "calc(var(--stroke-percent) * var(--percent-to-px)) var(--circumference)",
      transition: "var(--transition-length) ease var(--delay),stroke var(--transition-length) ease var(--delay)",
      transitionProperty: "stroke-dasharray,transform",
      transform: "rotate(calc(-90deg + var(--gap-percent) * var(--offset-factor) * var(--percent-to-deg)))",
      transformOrigin: "calc(var(--circle-size) / 2) calc(var(--circle-size) / 2)"
    }} />;
    $[5] = currentPercent;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = <svg fill="none" className="size-full" strokeWidth="2" viewBox="0 0 100 100">{t6}{t7}</svg>;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== currentPercent) {
    t9 = <span data-current-value={currentPercent} className="absolute inset-0 m-auto size-fit animate-in delay-[var(--delay)] duration-[var(--transition-length)] ease-linear fade-in">{currentPercent}</span>;
    $[10] = currentPercent;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t4 || $[13] !== t8 || $[14] !== t9) {
    t10 = <div className={t4} style={t5}>{t8}{t9}</div>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}